import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconTimer = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3124 9.10267L19.7082 7.70688L18.2943 6.29293L16.8982 7.68896C15.7921 6.82899 14.4582 6.25191 13.0012 6.06994L13.0011 3.99989H15.0011V2H9.00025V4.00006H11.0003V6.06909C7.06027 6.56396 4 9.92791 4 13.9998C4 18.4107 7.58896 22 12.0002 22C16.411 22 20.0003 18.411 20.0003 13.9998C20.0003 12.1539 19.3664 10.4568 18.3124 9.10267ZM6.00015 14.0002C6.00015 17.3093 8.69111 20.0002 12.0002 20.0002C15.3092 20.0002 18.0002 17.3091 18.0002 14.0002C18.0002 10.6912 15.3092 8.00019 12.0002 8.00019C8.69111 8.00019 6.00015 10.6912 6.00015 14.0002ZM15 12.9999H9V14.9999H15V12.9999Z"
        />
      </svg>
    );
  }
);
